module.exports = __webpack_public_path__ + "img/receive_money_icon.d8950679.svg";